/**
 * Created by lu on 2017/9/12.
 */
var nb = require('../../nb');
var accountMenu = require('./AccountMenu');
var wishMenu = require('./WishMenu');
var shopCartMenu = require('./ShopCartMenu');
var util = require('../../util');
var io = require('../../io/' + process.env.APP_ENV + '/io');
var seriesList = require('./SeriesList');
var businessListModel = require('./BusinessList');
var classList = require('./ClassList');
var xModel = require('../XModel');
var getWishList = require('../../io/' + process.env.APP_ENV + '/getWishList');
var getCart = require('../../io/' + process.env.APP_ENV + '/getCart');      //购物车接口
var getSeriesListModule = require('../../io/' + process.env.APP_ENV + '/seriesList/getSeriesListModule');
var getClassicSelect = require('../../io/' + process.env.APP_ENV + '/getClassicSelect');
var getProductMenu = require('../../io/' + process.env.APP_ENV + '/getProductMenu');
var businessList = [{
    imgUrl:'./image/header/111.jpg',
    name:'关于我们',
    href:'about'
},{
    imgUrl:'./image/header/112.jpg',
    name:'加盟申请',
    href:'join'
},{
    imgUrl:'./image/header/113.jpg',
    name:'联系我们',
    href:'contact'
}];
module.exports = nb.define({
    parent: nb.Model,
    mapping: {
        searchBox: require('./SearchBox'),
        loginMenu: nb.Model,
        accountMenu: accountMenu,
        wishMenu: wishMenu,
        shopCartMenu: shopCartMenu,
        seriesList: seriesList,
        businessList:businessListModel,
        classList: classList,
        dialog: require('./Dialog')
    },
    method: {
        init: function () {
            this._initEvent();
        },
        _initEvent: function () {
            var shopCartMenuModel = this.get('shopCartMenu');
            var seriesList = this.get('seriesList');
            var classList = this.get('classList');
            var businessList = this.get('businessList');
            var loginMenu = this.get('loginMenu');
            var dialog = this.get('dialog');
            loginMenu.set('loginHref', "login.html");
            nb.model.onChange(nb.opts.clientReady, function () {
                this.getHeaderMenuData();
            }, this);
            this.onChange('pageHref', function (inEvent, inData) {
                if(inData){
                    loginMenu.set('loginHref', "login.html")
                }else{
                    loginMenu.set('loginHref', "login.html?back=" + inData);
                }
            }, this);
            xModel.onChange('loginReady', function (inEvent, inReady) {
                if (inReady) {
                    this.set('isLogin', 'logon');
                    dialog.set('isLogin', 'logon');
                    this.getHeaderInfo();
                } else {
                    this.set('isLogin', '');
                    dialog.set('isLogin', '');
                }
                var nickName = $.cookie('ARTW_nickname') || '我的账户';
                this.set('accountName', '您好，' + nickName);
                dialog.set('accountName', '您好，' + nickName);
            }, this);
            this.onChange('seriesId', function (inEvent, inId) {
                seriesList.set('activeId', inId);
            }, this);
            this.onChange('classicId', function (inEvent, inId) {
                classList.set('activeId', inId);
            }, this);
            this.onChange('businessIndex', function (inEvent, inIndex) {
                businessList.set('businessIndex', inIndex);
            }, this);
            this.onChange('requestUpdateMenu', function (inEvent) {
                shopCartMenuModel.set('requestTotalPrice', inEvent.data);
            }, this);
            this.onChange('requestCart', function (inEvent) {
                this.getCartData();
            }, this);
            this.onChange('shopCartState', function (inEvent) {
                this.getCartData();
            }, this);
            this.onChange('requestWish', function (inEvent) {
                this.getWishData();
            }, this);
            dialog.onChange('exit', function () {
                this.set('exit', new Date());
            }, this);
            nb.model.onChange('refreshWishData', function () {
                this.getWishData();
            }, this);
            // shopCartMenuModel.onChange('shopCartCount', function (inEvent) {
            //     debugger
            //         this.set('shopCartCount', "(" + inEvent.data + ")", {
            //             skipSameValue: false
            //         });
            //     },this);
            // shopCartMenuModel.onChange('cartData', function (inEvent) {
            //     debugger
            //     this.set('cartData', inEvent.data);
            // }, this);
        },
        getHeaderMenuData: function () {
            var dialog = this.get('dialog');
            // getClassicSelect({
            //     scope: this,
            //     success: function (inResp) {
            //         var brandList = inResp.brandList || [];
            //         $.each(brandList,function (inIndex,inItem) {
            //             var name = inItem.name;
            //             switch (name){
            //                 case '奥斯汀':
            //                     inItem.imgUrl = './image/header/2.jpg';
            //                     break;
            //                 case '银湖':
            //                     inItem.imgUrl = './image/header/3.jpg';
            //                     break;
            //                 case '威廉斯堡':
            //                     inItem.imgUrl = './image/header/1.jpg';
            //                     break;
            //                 case '33127':
            //                     inItem.imgUrl = 'https://art-west-new-product.obs.cn-north-4.myhuaweicloud.com/seriesDetail/main_11_1539161671556.jpg?x-image-process=image/resize,m_fill,h_380,w_600,limit_0';
            //                     break;
            //                 case 'Thomas Bina':
            //                     inItem.imgUrl = 'https://art-west-new-product.obs.cn-north-4.myhuaweicloud.com/seriesDetail/main_12_1551844687082.jpg?x-image-process=image/resize,m_fill,h_380,w_600,limit_0';
            //                     break;
            //             }
            //         });
            //         this.set('seriesList', {
            //             items: inResp.brandList || []
            //         });
            //         dialog.set('seriesList', {
            //             items: inResp.brandList || []
            //         });
            //     }
            // });
            getSeriesListModule({
                data:{
                  pageSize:1000
                },
                scope: this,
                success: function (inResp) {
                    var rows = inResp.rows || [];
                    var items = [];
                    $.each(rows,function (inIndex,inItem) {
                        items.push({
                            id:inItem.id,
                            name:inItem.name,
                            imgUrl:inItem.imageUrl +'?x-image-process=image/resize,m_fill,h_380,w_600,limit_0',
                            seriesHref:'series.html?id='+inItem.id
                        })
                    });

                    this.set('seriesList', {
                        items: items
                    });
                    dialog.set('seriesList', {
                        items:items
                    });
                }
            });
            getProductMenu({
                scope: this,
                success: function (inResp) {
                    var list = inResp.list || [];
                    $.each(list, function (inIndex, inList) {
                        var name = inList.name || '';
                        switch (name) {
                            case '客厅':
                                inList.icon = 'icon-keting';
                                break;
                            case '餐厅':
                                inList.icon = 'icon-canting';
                                break;
                            case '书房':
                                inList.icon = 'icon-shufang';
                                break;
                            case '饰品':
                                inList.icon = 'icon-zhuangshi';
                                break;
                            case '卧房':
                                inList.icon = 'icon-woshi';
                                break;
                            case '装饰家具':
                                inList.icon = 'icon-zhuangshijiaju';
                                break;
                            case '床垫':
                                inList.icon = 'icon-chuangdian';
                                break;
                        }
                    });
                    this.set('classList', {
                        items: inResp.list || []
                    });
                }
            });
            this.set('businessList',{
                items:businessList
            });
            dialog.set('businessList', {
                items: businessList
            });
        },
        getHeaderInfo: function () {
            this.getCartData();
            this.getWishData();
        },
        getCartData: function () {
            var shopCartMenu = this.get('shopCartMenu');
            getCart({
                data: {},
                scope: this,
                success: function (inResp) {

                    var count = inResp.count;
                    if (count > 0) {
                        this.set('shopCartCount', "(" + inResp.summary.totalQty + ")");
                    } else {
                        this.set('shopCartCount', '');
                    }
                    shopCartMenu.set('data', inResp);
                    shopCartMenu.set('shopCartStates', 'showShopCart');
                },
                error: function (inResp) {
                    var code = inResp.error.code;
                    if (code === 401) {
                        this.set('isLogin', '');
                        io.setToken(null);
                        util.clearToken();
                    }
                }
            });
        },
        getWishData: function () {
            var wishMenu = this.get('wishMenu');
            getWishList({
                data: {},
                scope: this,
                success: function (inResp) {
                    var list = inResp.rows;
                    wishMenu.set('list', list);
                },
                error: function (inResp) {
                    var code = inResp.error.code;
                    if (code === 401) {
                        this.set('isLogin', '');
                        io.setToken(null);
                        util.clearToken();
                    }
                }
            });
        }
    }
});



//////////////////
// WEBPACK FOOTER
// ../src/js/model/header/Header.js
// module id = 35
// module chunks = 0 1 2 3 4 5 6 7 8 9 10 11 12 13 14 15 16 17 18 19 20 21 22 23 24 25 26 27 28 29 30 31 32